import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Lightning16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.7354 1.14706L9.91479 5.24997H13.4999C14.123 5.24997 14.475 6.00142 14.0761 6.4801L6.57617 15.4801C6.09048 16.0629 5.11578 15.5968 5.26456 14.8529L6.08515 10.75H2.5C1.8769 10.75 1.52494 9.99851 1.92383 9.51983L9.42377 0.519833C9.90946 -0.062993 10.8842 0.403123 10.7354 1.14706ZM4.10127 9.24997H7.91485L7.31469 12.2508L11.8987 6.74997H8.08509L8.68525 3.74915L4.10127 9.24997Z'
      fill='currentColor'
    />
  </Svg>
);

Lightning16.displayName = 'Lightning16';
export default Lightning16;
